import classNames from 'classnames';
import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { EVENT_TYPE_WIDTH } from '../constant';
import styles from './EventColoredCollapsibleSection.module.sass';

interface EventColoredCollapsibleSectionProps {
  className?: string;
  eventColor: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const EventColoredCollapsibleSection: React.FC<EventColoredCollapsibleSectionProps> = ({
  className,
  eventColor,
  children,
  style,
}) => {
  const nodeRef = React.useRef(null);

  return (
    <CSSTransition appear in={true} timeout={200} classNames="fade" nodeRef={nodeRef}>
      <div
        ref={nodeRef}
        className={classNames(styles.wrapper, className)}
        style={{ backgroundColor: eventColor, paddingLeft: `${EVENT_TYPE_WIDTH}px`, ...style }}
      >
        {children}
      </div>
    </CSSTransition>
  );
};
